<!-- OrderDetailBody.vue -->
<template>
    <div>
        <div class="common-header-wrap">
            <mt-header title="订单详情" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div
                class="order-body"
                v-if="order_info"
        >
            <div class="order_state">
                <i class="iconfont" v-if="order_info.order_state == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{order_info.state_desc}}</span>
            </div>

            <div class="address">
                <div>
                    <span>{{ order_info.reciver_name }}</span>
                    <span class="mobile">{{ order_info.reciver_phone }}</span>
                </div>
                <p style="-webkit-box-orient: vertical; -webkit-line-clamp: 2;">
                    {{ order_info.reciver_addr }}
                </p>
            </div>

            <div
                    class="containers"
                    v-for="item in order_info.goods_list"
                    v-bind:key="item.goods_id"
            >

                <img
                        class="photo"
                        v-bind:src="item.image_240_url"
                />
                <div class="right-wrapper">
                    <label class="title">{{ item.goods_name }}</label>
                    <label class="property">{{ item.goods_spec }}</label>
                    <div class="desc-wrapper">
                        <label class="price"
                        >$ {{ item.goods_price }}</label
                        >
                        <label class="count">x{{ item.goods_num }}</label>
                    </div>
                </div>
            </div>

            <div class="detail">
                <div class="number">
                    <label
                    >订单编号：{{ order_info.order_sn }}
                    </label>
                    <p>
                        下单时间：{{order_info.add_time}}
                    </p>
                </div>
                <div class="number" v-if="(order_info.promotion && order_info.promotion.length) || order_info.voucher_code || order_info.extend_order_common.mallvoucher_price">    
                    <p v-if="order_info.promotion && order_info.promotion.length">
                        {{order_info.promotion}}
                    </p>
                    <p v-if="order_info.voucher_code">
                        使用了面额为 {{order_info.voucher_price}} 元的代金券
                    </p>
                    <p v-if="order_info.extend_order_common.mallvoucher_price">
                        使用了面额为 {{order_info.extend_order_common.mallvoucher_price}} 元的代金券
                    </p>
                </div>
                <div class="pay" v-if="order_info.payment_name">
                    <p>支付方式：{{ order_info.payment_name }}</p>
                </div>

            </div>

            <div
                    class="desc section-header section-footer"
            >
                <div class="container">
                    <label class="title">商品总额</label>
                    <label class="subtitle">${{ order_info.goods_amount }}</label>
                </div>
                <div class="container">
                    <label class="title">运费</label>
                    <label class="subtitle">${{ order_info.shipping_fee }}</label>
                </div>
                <label class="amount"
                >实付款 : <span> ${{ order_info.order_amount }}</span>
                </label>
            </div>

        </div>
    </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { getOrderInfo } from '../../../api/sellerOrder'
export default {
  name: 'SellerOrderDetail',
  data () {
    return {
      order_info: {}
    }
  },

  created: function () {
    if (this.$route.query.order_id) {
      getOrderInfo(this.$route.query.order_id).then(res => {
        this.order_info = res.result.order_info
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
    .common-header-wrap .common-header{box-shadow: unset}
    .order-body {
        overflow: auto;
        height: 100%;
        position: absolute;
        width: 100%;
        .desc{
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
            }
            .title {
                width: 5rem;
                font-size:$subFontSize;
                color: #333;
                margin-left: 0.6rem;
            }
            .subtitle {
                flex: 1;
                margin-left: 1rem;
                margin-right: 0.6rem;
                color: $primaryColor;
                font-size:$subFontSize;
                text-align: right;
            }
        }

    }
    .order_state {
        background:$primaryColor;
        height: 3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size:$h2;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width: 4rem;
        height: 4rem;
        margin: 0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis: 4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding:0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        margin-top: 0.75rem;
        color: #333;
        font-size:$subFontSize;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .property {
        font-size:$fontSize;
        color: #7c7f88;
        padding-top: 0.5rem;
    }
    .count {
        margin-top: 0.2rem;
        color: #7c7f88;
        font-size:$fontSize;
        margin-right: 0.5rem;
    }
    .desc-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 1.05rem;
    }
    .price {
        color: $primaryColor;
        font-size:$mainFontSize;
        margin-left:0;
    }
    .count {
        color: #7c7f88;
        font-size:$h2;
        margin-right: 0.5rem;
    }
    .address {
        height: 4.35rem;
        background-color: #fff;
        margin-bottom:0.5rem;
        div {
            padding:0.5rem 0.5rem 0;
        }
        img {
            height: 0.8rem;
        }
        span {
            color: #333;
            font-size:$h2;
            &.mobile {
                padding-left: 1.05rem;
            }
        }
        p {
            margin:0.25rem 0.9rem 0.55rem 0.5rem;
            font-size:$subFontSize;
            color: #7c7f88;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 2.3rem;
        background-color: #fff;
        margin-top: 0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size:$fontSize;
            color: #333;
            padding-right: 0.3rem;
        }
        img {
            width: 0.6rem;
            height: 0.65rem;
        }
    }

    .detail {
        display: flex;
        flex-direction: column;
        font-size:$subFontSize;
        color: #7c7f88;
        background-color: #fff;
        margin: 0.4rem 0;
        box-sizing: border-box;
        .number {
            padding: 0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top: 0.3rem;
                font-size:$subFontSize;
            }
            button {
                color: #7c7f88;
                height: 1rem;
                background-color: #fff;
                border: 1px solid #7c7f88;
                width: 2.7rem;
                height: 1rem;
                border-radius: 0.1rem;
                font-size:$subFontSize;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding: 0.7rem 0.8rem;
        }
        .givetime {
            padding: 0.7rem 0.8rem;
            font-size:$subFontSize;
        }
        input {
            background-color: #fff;
            border: 1px solid #7c7f88;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding-top: 0.6rem;
        box-sizing: border-box;
        margin-bottom: 4rem;
        .desc-item {
            flex: 1;
            margin-top: 0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-end;
            font-size:$subFontSize;
            color: #333;
            padding-right: 0.75rem;
            border-top: 1px solid #e8eaed;
            margin-top: 0.6rem;
            height: 2.25rem;
            line-height: 2.25rem;
            span {
                font-size:$h2;
                color: $primaryColor;
            }
        }
    }
    .ship {
        margin-bottom:0;
    }
</style>

<!-- 字体图标样式覆盖 -->
<style lang="scss">
    .mint-toast-icon {
        font-size: 1.9rem;
    }
    button {
        padding: 0;
    }
</style>
